import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import getMapSvcOps from "../../../../../tools/getMapSvcOps";

// !! the portal item for the Estuarine Inventory doesn't return the sub-layer items

//** setting this up to loop through the url layer ids for the layers and generate the items */

const url = 'https://services1.arcgis.com/QWdNfRs7lkPq4g4Q/ArcGIS/rest/services/Estuarine_Inventory_of_New_Jersey/FeatureServer/'

const portalId = '3f716258e7244ff3b536d1439d382add'

const urlIdArray = [5,6,7]

const savGroup = {
    id: 'sav',
    title: "Submerged Aquatic Vegetation (SAV)",
    type: 'group',
    items: [],
};

urlIdArray.map(async (id) => {
    let item = new FeatureLayer({
        url: `${url}${id}`,
        visible: true,
        mapService: `${url}${id}`,
        popupEnabled: true,
        
    })
    getMapSvcOps(item).then((d) => {
        savGroup.items.push(
            {
                key: `sav${id}`,
                id: `sav${id}`,
                layerId: `sav${id}`,
                type: 'layer',
                item,
                meta: {
                    title: d.title,
                    layerDescription: d.description,
                    mapService: `${url}${id}`,
                    authoritiveSource: `https://dep.nj.gov/njfw/`
                }
            }
        )
    })
    
})

// console.log('savLayers', savGroup.items)



export { savGroup}
